// Libs
import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import Lottie from 'react-lottie';
// Actions
import { setCurrentQRCodeTicket } from '../../actions';
// Icons
import successAnimation from '../../assets/check.json';

const NewTicketFormValidation = props => {
    const [t] = useTranslation();
    const dispatch = useDispatch();
    const relatedTicket = props?.relatedTicket;

    useEffect(() => {
        dispatch(setCurrentQRCodeTicket(null));
    }, [relatedTicket]);

    return (
        <>
            <span className={'valid-incident-text'}>
                {`${t('passages:your_request')} `}
                {`${t('passages:was_sent')} `}
            </span>
            <span className={'incident-tile-summary'}>{relatedTicket?.title}</span>
            <div className="valid-incident-animation">
                <Lottie
                    options={{
                        loop: false,
                        autoplay: true,
                        animationData: successAnimation
                    }}
                    height={'100%'}
                    width={'100%'}
                />
            </div>
        </>
    );
};

export default NewTicketFormValidation;
